import { AlertTriangle } from 'lucide-react';

import type { TemplateWizardStep } from '../types';

import { featureGroupForTypes } from './draft';

/**
 * "Not available yet" placeholder (design §16) — the frame-owned fallback for
 * any step whose renderer isn't registered (`stepRegistry.has(type) === false`
 * or a forced-unknown duplicate). NEVER throws, contributes no draft value;
 * P4/P5 modules replace it by registering their type. A frame component, never
 * a registry module.
 */
export function UnknownStepPlaceholder({ step }: { step: TemplateWizardStep }) {
  const group = featureGroupForTypes([step.type]);
  const unlockCopy =
    group === 'additional'
      ? 'It unlocks when the matching features arrive.'
      : `It unlocks when ${group} features arrive.`;

  return (
    <div className="space-y-2 rounded-lg border p-6">
      <p className="flex items-center gap-2 text-base font-medium">
        <AlertTriangle className="h-5 w-5 shrink-0 text-muted-foreground" aria-hidden="true" />
        This step isn't available yet
      </p>
      {step.required ? (
        <p className="text-sm text-muted-foreground">
          This step is required for this template, so you can't finish creating this agent yet.{' '}
          {unlockCopy}
        </p>
      ) : (
        <p className="text-sm text-muted-foreground">
          “{step.title}” needs a feature that hasn't been turned on yet. You can still set up the
          rest of the agent.
        </p>
      )}
    </div>
  );
}
